import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';

import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ProductService } from 'src/app/core/services/product.service';
import { UserAccountProductDto } from 'src/app/core/dtos/dto';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ProductTypeEnum, BrandEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-my-products',
  templateUrl: './my-products.component.html',
  styleUrls: ['./my-products.component.scss']
})
export class MyProductsComponent implements OnInit, OnDestroy {

  @Input() products: UserAccountProductDto[];
  @ViewChild('ConfirmDownload') modalContent: string;

  brandId: BrandEnum;
  downloadEbookSubscription: Subscription;
  downloadFileSubscription: Subscription;
  ebookName: string;
  celpipStudyGuideListeningSpeakingproductIds = [52, 53];
  celpipStudyGuideReadingWritingproductIds = [54, 55];
  productOptionTypeId = ProductTypeEnum.ProductOption;
  hasCaelPrepAudioFiles: boolean;
  contactUrl = "https://www.paragontesting.ca/contact";
  celpipStudyGuideListeningSpeakingUrl = "https://secure.paragontesting.ca/InstructionalProductResources/CelpipStudyGuideListeningSpeakingNL";
  celpipStudyGuideReadingWritingUrl = "https://secure.paragontesting.ca/InstructionalProductResources/CelpipStudyGuideReadingWriting";


  constructor(
    private productService: ProductService,
    private toastService: HotToastService,
    private configHelper: ConfigHelper,
    private loadingService: LoadingService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    const productIds = this.products.map(x => x.productId);
    const productIdsHavingAudio = [8101, 8102, 8103, 8104, 8105, 8106];
    if (productIds.some(id => productIdsHavingAudio.indexOf(id) >= 0)) {
      this.hasCaelPrepAudioFiles = true;
    }
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  productClick(event: Event, product: UserAccountProductDto) {
    event.preventDefault();
    switch (product.productTypeId) {

      case ProductTypeEnum.ElectronicProductOnline:
      case ProductTypeEnum.OnlineProgram:
        this.establishInstructionalProductLink(product);
        break;

      case ProductTypeEnum.ElectronicProductEBook:
        this.downloadEbookName(product);
        break;

      case ProductTypeEnum.ElectronicProductFile:
        this.downloadProductFile(product);
        break;

      default:
        break;
    }
  }

  establishInstructionalProductLink(product: UserAccountProductDto) {
    this.productService.getInstructionalProductsUrl(product.productId)
      .subscribe(
        result => {
          const productLink = result.content;
          window.open(productLink, '_blank');
        },
        () => {
          this.toastService.warning("Failed to generate a product link");
        });
  }

  downloadEbookName(product: UserAccountProductDto) {
    this.downloadEbookSubscription = this.productService.getEbookName(product.productId, product.userAccountProductId)
      .subscribe(
        res => {
          this.ebookName = res.content;
          this.modalService.open(this.modalContent);
          this.loadingService.hide();
        }
        ,
        () => {
          this.toastService.warning('Failed to generate a download link');
        }
      );
  }

  downloadEbook() {
    this.modalService.dismissAll();
    const downloadLink = this.configHelper.getApiUrl("/User/Account/DownloadEbook" + '?filename=' + this.ebookName);
    window.open(downloadLink);
  }

  downloadProductFile(product: UserAccountProductDto) {
    this.loadingService.show();
    this.downloadFileSubscription = this.productService.downloadProductFile(product.productId)
      .subscribe(
        res => {
          const dataType = res.type;
          const blob = new Blob([res], { type: dataType });
          const data = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = data;
          downloadLink.setAttribute('download', `${product.productName}.pdf`);
          downloadLink.click();
          this.loadingService.hide();
        }
        ,
        () => {
          this.toastService.warning('File download failed');
          this.loadingService.hide();
        }
      );
  }

  downloadPDF(fileName: string) {
    this.loadingService.show();
    const downloadLink = this.configHelper.getApiUrl("/User/Account/DownloadPDF" + '?filename=' + fileName);
    window.open(downloadLink);
    this.loadingService.hide();
  }

  ngOnDestroy(): void {
    this.downloadFileSubscription?.unsubscribe();
    this.downloadEbookSubscription?.unsubscribe();
  }

}

